module.exports = __webpack_public_path__ + "img/gg1.e1d47b1e.jpg";